/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IssueResourceSelectorKind {
    Selection = '0',
    None = 1,
    Fixed = 2,
    Self = 3,
}
